import { createFields } from "./report.section";
import { createConditionForm } from "./report.condition";
import { createLoading } from "../../../utils/loading";
import { required } from "../../../utils/validate";
import i18n from "../../../i18n";
import { useForm as createUseForm } from "@ant-design-vue/use";
import store from "../../../store";

export const { isLoading, setIsLoading } = createLoading();

export const callUserReport = ({ props, searchQuery }) => {
    const propsUserId = props.userId;
    const userId = store.state.resource.auth.info?.user?.id || propsUserId;
    const where = [{ name: "refUser.id", type: "UUID", operator: "=", value: userId }];
    if (searchQuery) {
        where.push({ openBucket: true, name: "refReport.seq", type: "String", operator: "like", value: searchQuery });
        where.push({ closeBucket: true, logic: "OR" ,name: "refReport.title", type: "String", operator: "like", value: searchQuery });
    }
    return store.dispatch("resource/v1/security/userReport/cacheFindAll", {
        where: where,
        sort: [{ name: "refReport.seq", type: "ASC" }],
        criteria: { select: ["**"], },
    });
};

export const createForm = ({ props }) => {
    const refReport = !props.refReportId || !props.refReportAddress ? null : {
        id: props.refReportId,
        address: props.refReportAddress,
    };
    return {
        refUserReport: null,
        refReport: refReport,
    };
};

export const createRules = ({ key }) => {
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refUserReport`]: [required],
    };
};

export const createFormTitle = ({ props }) => {
    return props.isShowTitle === true || props.isShowTitle === "true" ? i18n.global.t("model.report.modelName") : "";
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createFields({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
};